<h5>Tabla de posiciones</h5>

<div class="table-container">
  <!-- <div class="table-responsive"> -->
  <table mat-table [dataSource]="dataSource()">

    <!-- Posicion -->
    <ng-container matColumnDef="rank" sticky>
      <th mat-header-cell *matHeaderCellDef rowspan="2">
        Posición
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.rank }}
      </td>
    </ng-container>

    <!-- Jugador -->
    <ng-container matColumnDef="player">
      <th mat-header-cell *matHeaderCellDef rowspan="2">
        Jugador
      </th>
      <td mat-cell *matCellDef="let element" class="text-black">
        <div class="info d-flex align-items-center">
          <div class="image" style="margin-top: 5px;">
            <img
              [ngSrc]="bucketUrl + '/images/avatars/' + element.avatarImg"
              width="40"
              height="40"
              class="rounded-circle"
              alt="admin-image"
              style="max-width: none;"
            />
          </div>
          <span class="d-block fw-medium" style="margin-left: 10px;">
            {{ element.drawing?.team?.label }}
            <!-- @TODO -->
            <!-- @if (element.player?.eventRank) {
              ({{ element.player?.eventRank }})
            } -->
          </span>
          @if (element.isSeed) {
            <div
              matTooltip="Siembra"
              matTooltipPosition="above"
              class="icon rounded-circle position-relative text-daxa text-center"
            >
              <i class="material-symbols-outlined" style="color: #008000;">psychiatry</i>
            </div>
          }
          @if (element.isClassified) {
            <span class="material-symbols-outlined" style="margin-left: 10px; color: green;">
              check
            </span>
          }
        </div>
      </td>
    </ng-container>

    <!-- Partidos -->
    <ng-container matColumnDef="matches">
      <th mat-header-cell *matHeaderCellDef colspan="4">
        Partidos
      </th>
    </ng-container>

    <!-- Partidos jugados -->
    <ng-container matColumnDef="matchesPlayed">
      <th mat-header-cell *matHeaderCellDef>
        <!-- Jugados -->
        <span matTooltip="Jugados" matTooltipPosition="above">J</span>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.matchesPlayed | number : '1.0-2' : 'en' }}
      </td>
    </ng-container>

    <!-- Partidos a favor -->
    <ng-container matColumnDef="matchesFor">
      <th mat-header-cell *matHeaderCellDef>
        <!-- A favor -->
        <span matTooltip="A favor" matTooltipPosition="above">F</span>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.matchesFor | number : '1.0-2' : 'en' }}
      </td>
    </ng-container>

    <!-- Partidos en contra -->
    <ng-container matColumnDef="matchesAgainst">
      <th mat-header-cell *matHeaderCellDef>
        <!-- En contra -->
        <span matTooltip="En contra" matTooltipPosition="above">C</span>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.matchesAgainst | number : '1.0-2' : 'en' }}
      </td>
    </ng-container>

    <!-- Diferencia de partidos -->
    <ng-container matColumnDef="matchesDiff">
      <th mat-header-cell *matHeaderCellDef>
        <!-- Diferencia -->
        <span matTooltip="Diferencia" matTooltipPosition="above">D</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <span class="text-black">{{ (element.matchesFor - element.matchesAgainst) | number : '1.0-2' : 'en' }}</span>
      </td>
    </ng-container>

    <!-- Sets -->
    <ng-container matColumnDef="sets">
      <th mat-header-cell *matHeaderCellDef colspan="3">
        Sets
      </th>
    </ng-container>

    <!-- Sets a favor -->
    <ng-container matColumnDef="setsFor">
      <th mat-header-cell *matHeaderCellDef>
        <!-- A favor -->
        <span matTooltip="A favor" matTooltipPosition="above">F</span>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.setsFor | number : '1.0-2' : 'en' }}
      </td>
    </ng-container>

    <!-- Sets en contra -->
    <ng-container matColumnDef="setsAgainst">
      <th mat-header-cell *matHeaderCellDef>
        <!-- En contra -->
        <span matTooltip="En contra" matTooltipPosition="above">C</span>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.setsAgainst | number : '1.0-2' : 'en' }}
      </td>
    </ng-container>

    <!-- Diferencia de sets -->
    <ng-container matColumnDef="setsDiff">
      <th mat-header-cell *matHeaderCellDef>
        <!-- Diferencia -->
        <span matTooltip="Diferencia" matTooltipPosition="above">D</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <span class="text-black">{{ (element.setsFor - element.setsAgainst) | number : '1.0-2' : 'en' }}</span>
      </td>
    </ng-container>

    <!-- Games -->
    <ng-container matColumnDef="games">
      <th mat-header-cell *matHeaderCellDef colspan="3">
        Games
      </th>
    </ng-container>

    <!-- Games a favor -->
    <ng-container matColumnDef="gamesFor">
      <th mat-header-cell *matHeaderCellDef>
        <!-- A favor -->
        <span matTooltip="A favor" matTooltipPosition="above">F</span>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.gamesFor | number : '1.0-2' : 'en' }}
      </td>
    </ng-container>

    <!-- Games en contra -->
    <ng-container matColumnDef="gamesAgainst">
      <th mat-header-cell *matHeaderCellDef>
        <!-- En contra -->
        <span matTooltip="En contra" matTooltipPosition="above">C</span>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.gamesAgainst | number : '1.0-2' : 'en' }}
      </td>
    </ng-container>

    <!-- Diferencia de games -->
    <ng-container matColumnDef="gamesDiff">
      <th mat-header-cell *matHeaderCellDef>
        <!-- Diferencia -->
        <span matTooltip="Diferencia" matTooltipPosition="above">D</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <span class="text-black">{{ (element.gamesFor - element.gamesAgainst) | number : '1.0-2' : 'en' }}</span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="header1Columns"></tr>
    <tr mat-header-row *matHeaderRowDef="header2Columns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <!-- <td class="mat-cell" colspan="4">No data matching the filter "{{ input.value }}"</td> -->
      <td class="mat-cell" colspan="4">No data matching the filter</td>
    </tr>
  </table>
  <!-- </div> -->
</div>
